import styled from 'styled-components';

const DeliveryInfoContainer = styled.div`
  color: ${({ theme }) => theme.colors.corporateWhite};
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default DeliveryInfoContainer;
